export default __webpack_public_path__ + "static/media/gallery40.b363269c.webp";